import { NgModule } from '@angular/core';
import { RequiredControlPipe } from '../required-control.pipe';

@NgModule({
  declarations: [RequiredControlPipe],
  imports: [],
  exports: [RequiredControlPipe],
})
export class RequiredControlPipeModule {}
